import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyFaqLayoutComponent } from './empty-faq-layout/empty-faq-layout.component';
import { SharedModule } from '@feature/shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    EmptyFaqLayoutComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
  ]
})
export class EmptyFaqLayoutModule { }